import React from 'react';
import { IoCamera, IoPerson } from 'react-icons/io5';
import { User } from '@/types';
import { ProfileStrength as ProfileStrengthType } from '../types';

interface ProfileStrengthProps {
  user: User;
  profileStrength: ProfileStrengthType;
}

const ProfileStrength: React.FC<ProfileStrengthProps> = ({ user, profileStrength }) => {
  const getStrengthColor = (percentage: number) => {
    if (percentage >= 80) return { bg: 'bg-green-500', text: 'text-green-600' };
    if (percentage >= 60) return { bg: 'bg-yellow-500', text: 'text-yellow-600' };
    return { bg: 'bg-red-500', text: 'text-red-600' };
  };

  const strengthItems = [
    { label: 'Personal Info', value: profileStrength.personalInfo },
    { label: 'Test Scores', value: profileStrength.testScores },
    { label: 'Activities', value: profileStrength.activities },
    { label: 'Essays', value: profileStrength.essays },
    { label: 'Recommendations', value: profileStrength.recommendations },
  ];

  return (
    <div className="profile-strength-card">
      <div className="card-header">
        <h2 className="card-title">Profile Strength</h2>
        <span className="profile-strength-percentage">{profileStrength.overall}%</span>
      </div>

      <div className="profile-section">
        <div className="profile-avatar-container">
          {user?.photoURL ? (
            <>
              <img
                alt="Profile"
                className="profile-avatar"
                src={user.photoURL}
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                  const iconContainer = e.currentTarget.nextElementSibling as HTMLElement;
                  if (iconContainer?.classList.contains('profile-avatar-icon')) {
                    iconContainer.style.display = 'flex';
                  }
                }}
              />
              <div className="profile-avatar-icon" style={{ display: 'none' }}>
                <IoPerson style={{ fontSize: '2rem', color: 'var(--text-primary)' }} />
              </div>
            </>
          ) : (
            <div className="profile-avatar-icon">
              <IoPerson style={{ fontSize: '2rem', color: 'var(--text-primary)' }} />
            </div>
          )}
          <button className="profile-camera-button">
            <IoCamera className="camera-icon" />
          </button>
        </div>
        <h3 className="profile-name">{user?.name || 'User'}</h3>
        <p className="profile-class">Class of 2025</p>
        <p className="profile-school">Lincoln High School</p>
      </div>

      <div className="strength-bars">
        {strengthItems.map((item) => {
          const colors = getStrengthColor(item.value);
          return (
            <div key={item.label} className="strength-bar-item">
              <span className="strength-label">{item.label}</span>
              <div className="strength-bar-wrapper">
                <div className="strength-bar-bg">
                  <div 
                    className={`strength-bar-fill ${colors.bg}`} 
                    style={{ width: `${item.value}%` }}
                  />
                </div>
                <span className={`strength-percentage ${colors.text}`}>{item.value}%</span>
              </div>
            </div>
          );
        })}
      </div>

      <button className="complete-profile-button">
        Complete Profile
      </button>
    </div>
  );
};

export default ProfileStrength;